The overarching phase of the application or position.
